module.exports = __webpack_public_path__ + "images/help/video-me-small@2x-decf7d03616a52fbfa75a7fc36e8c311.png";